import store from '@/store';
import { Notification } from '@/utils/helpers/notification';

const guard = async (to, from, next) => {
  const admissionStatus = store.state.currentAdmission.data.status;

  const isCheckinConclusionSimpleToConfirmArrival =
    from.name === 'checkin-conclusion-simple' && to.params?.unitArrival;
  const isAdmissionDone =
    admissionStatus === 'ADMISSION_DONE' || admissionStatus === 'CHECK_IN_DONE';
  const conclusionRoutes = [
    'checkin-conclusion',
    'checkin-conclusion-simple',
    'checkin-conclusion-mobile',
  ];
  const isConclusionRoutes = conclusionRoutes.includes(from.name);
  if (
    isAdmissionDone &&
    isConclusionRoutes &&
    to.name !== 'checkIn' &&
    !isCheckinConclusionSimpleToConfirmArrival
  ) {
    const conclusionPageOrigen = from.name;

    Notification.error({
      message:
        'Seus dados foram enviados. Você pode solicitar a alteração dos dados no guichê de atendimento.',
      duration: 3000,
    });

    next({
      name: conclusionPageOrigen,
    });
  }

  next();
};

export default guard;
